import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-container" }
const _hoisted_2 = { style: {"text-transform":"capitalize"} }
const _hoisted_3 = { class: "Map__footer" }
const _hoisted_4 = {
  key: 1,
  class: "Map__report"
}

import { computed, onMounted, ref, watch } from "vue";
import { useMainStore } from "../../stores/main";
import { Election, Party, VoteSetHeavy } from "../../types";
import MapParties from "./MapParties.vue";
import { ratio } from "./map/settings";
import { App } from "./map/App";
import { Cell } from "./map/Cell";
import { addToPrototype } from "./map/canvasPrototype";
import MapCell from "./cell/MapCell.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Map',
  props: {
    election: {},
    parties: {}
  },
  setup(__props: any) {

const props = __props;

addToPrototype();

const store = useMainStore();
const el = ref<HTMLCanvasElement>();
const app = ref<App>();
const currentCell = ref<Cell | null>(null);

const callback = (cell: Cell) => {
    if (cell.voteSets.length > 0) {
        // const voteSet = cell.voteSets[0];
        // store.selectMunicipality(voteSet[1].cbs_code);
        // store.selectParty(voteSet[2].id);
        // currentCell.value = cell;
    }
};

const electionType = computed(() => {
    return props.election.type.split("-").join(" ");
});

const report = ref(null);

const create = () => {
    if (el.value) {
        const start = new Date();
        const voteSets: VoteSetHeavy[] = props.election.results
            .map((v) => {
                const municipality = store.municipalityLib[v[0]];
                const party = store.partyLib[v[1]];
                const votes = v[2];
                return { municipality, party, votes, distance: 0 };
            })
            .filter((v) => v.municipality && v.party);
        const canvas = el.value;
        const ctx = canvas.getContext("2d");
        if (ctx) {
            const netWidth = store.width - 2 * padding.value;
            canvas.width = store.width;
            canvas.height = store.width * ratio;
            app.value = new App(
                ctx,
                netWidth,
                netWidth * ratio,
                voteSets,
                store.grid,
                callback,
                props.parties.map((p) => p.id),
                store.mapMode,
                store.winnerTakesAll
            );
            report.value = app.value.getReport();
        }
        const end = new Date();
        // console.log("create time", end.getTime() - start.getTime());
    }
};

const height = computed(() => (store.width * 29.7) / 21);
const padding = computed(() => store.width / 13);

watch(
    () => store.grid,
    () => {
        // update function is slow for some reason, dont understand why
        // app.value.updateGrid(store.grid, [...store.voteSetsHeavy]);
        create();
        currentCell.value = null;
    }
);

watch(
    () => store.winnerTakesAll,
    () => {
        create();
    }
);

watch(
    () => store.mapMode,
    () => {
        app.value?.switchMode(store.mapMode);
    }
);

watch(
    () => store.width,
    () => {
        create();
        currentCell.value = null;
    }
);

watch(
    () => props.parties,
    () => {
        create();
        //app.value?.updateSelectedParties(props.parties.map((p) => p.id));
    },
    {
        deep: true,
    }
);

onMounted(() => {
    create();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "Map",
      style: _normalizeStyle({
                height: height.value + 'px',
                padding: padding.value + 'px',
            })
    }, [
      _createElementVNode("canvas", {
        ref_key: "el",
        ref: el
      }, null, 512),
      _createElementVNode("div", {
        class: "Map__title",
        style: _normalizeStyle({
                    width: _unref(store).width / 3.5 + 'px',
                    'font-size': _unref(store).width / 35 + 'px',
                })
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", null, "Verkiezingen", -1)),
        _createElementVNode("div", _hoisted_2, _toDisplayString(electionType.value), 1),
        _createElementVNode("div", null, _toDisplayString(__props.election.year), 1)
      ], 4),
      _createElementVNode("div", _hoisted_3, [
        (_unref(store).mapMode)
          ? (_openBlock(), _createBlock(MapParties, {
              key: 0,
              parties: __props.parties
            }, null, 8, ["parties"]))
          : _createCommentVNode("", true),
        (report.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createTextVNode(" Op deze kaart is ", -1)),
              _createElementVNode("strong", null, _toDisplayString(report.value.coverage) + "%", 1),
              _cache[3] || (_cache[3] = _createTextVNode(" van de stemmers vertegenwoordigd. [", -1)),
              _createVNode(_component_router_link, { to: { name: 'Grid' } }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("UITLEG", -1)
                ]))]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createTextVNode("]. ", -1))
            ]))
          : _createCommentVNode("", true),
        (currentCell.value)
          ? (_openBlock(), _createBlock(MapCell, {
              key: 2,
              cell: currentCell.value,
              style: _normalizeStyle({
                        width: _unref(store).width + 'px',
                    })
            }, null, 8, ["cell", "style"]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ]))
}
}

})